'use client'

import './FastMarque.scss'

import Image from 'next/image'
import Marquee from 'react-fast-marquee'

import useScrollable from '@/src/entities/application/hooks/useScrollable'
import { IPreview } from '@/src/shared/model'

export type IFastMarque = {
  className?: string
  gallery: IPreview[] | []
  isScrollable?: boolean
}

const FastMarque = ({ gallery = [], isScrollable = false }: IFastMarque) => {
  const { scrollContainerRef, scrollableGallery } = useScrollable(gallery, isScrollable)

  return (
    <div
      ref={isScrollable ? scrollContainerRef : null}
      className={`partners-fast-marquee ${isScrollable ? 'scrollable' : ''}`}
    >
      <Marquee
        speed={30}
        pauseOnHover
        loop={0}
        style={{ whiteSpace: 'nowrap', animationPlayState: 'var(--pause, running)' }}
      >
        <div className="gallery__grid">
          {scrollableGallery.map((photo, key) => (
            <div key={key} className="gallery__cell">
              {photo?.mediumPreview && (
                <Image
                  priority
                  src={photo.mediumPreview ?? null}
                  width="673"
                  height="504"
                  alt={`photo-${key}`}
                />
              )}
            </div>
          ))}
        </div>
      </Marquee>
    </div>
  )
}

export default FastMarque
